import React from 'react';
import ContextHelp from './ContextHelp';
import { getCalidadDisplay, HELP_CALIDAD } from '../../../utils/finanzasUi';

export default function CalidadFinancieraCard({ calidadFinanciera, cobertura = null, compact = false }) {
  if (!calidadFinanciera) return null;

  const ventasCobertura = cobertura != null ? (Number(cobertura.ventas_total) || 0) : null;
  // Sin cobertura explícita o universo vacío → no evaluar (evita EXCELENTE con ventas_total=0/stale).
  const coberturaEvaluable = cobertura != null && ventasCobertura > 0;
  const evaluable = calidadFinanciera.evaluable !== false
    && calidadFinanciera.score != null
    && coberturaEvaluable;

  const score = evaluable ? (calidadFinanciera.score ?? null) : null;
  const { label, badgeClass } = getCalidadDisplay(score, { evaluable });
  const titleClass = compact ? 'text-xs font-medium text-e0e3-muted' : 'text-sm font-medium text-e0e3-muted';
  const padClass = compact ? 'p-5' : 'p-5 lg:p-6';
  const scoreClass = compact ? 'text-2xl' : 'text-2xl lg:text-3xl';
  const motivo = calidadFinanciera.motivoNoEvaluable
    || (!evaluable
      ? (cobertura == null
        ? 'Falta cobertura financiera del período para evaluar la calidad de los datos.'
        : ventasCobertura === 0
          ? 'Hacen falta ventas con evidencia de costo en el período para evaluar la calidad de los datos.'
          : 'Hacen falta datos suficientes para evaluar la calidad de los datos financieros.')
      : null);

  return (
    <div className={`rounded-xl border border-e0e3-border/40 bg-e0e3-surface/40 ${padClass} min-h-[7rem] flex flex-col justify-center`}>
      <p className={`${titleClass} flex items-center gap-1.5`}>
        Calidad de datos financieros
        <ContextHelp text={HELP_CALIDAD} label="Ayuda sobre calidad de datos financieros" />
      </p>
      {evaluable ? (
        <p className={`${scoreClass} font-bold text-e0e3-foreground mt-2`}>{score} %</p>
      ) : (
        <p className={`${scoreClass} font-bold text-e0e3-muted mt-2`}>—</p>
      )}
      <span
        className={`mt-2 inline-flex w-fit items-center rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide ${badgeClass}`}
      >
        {label}
      </span>
      {!evaluable && motivo && (
        <p className="mt-2 text-xs text-e0e3-muted leading-snug">{motivo}</p>
      )}
    </div>
  );
}
